<template>
    <main class="question-single-main">
        

        <!-- Header -->
        <theme-header />

        <!-- Question Single Header -->
        <question-single-header 
            title="The best way to process data between a client application and a web api?" 
            askedDate="today"
            modifiedDate="today"
            viewedTimes="9 times"
            />

        <!-- Question Single Content -->
        <question-single-details />


        <!-- Footer -->
        <theme-footer />

    </main>
</template>

<script>
import ThemeHeader from '@/components/common/ThemeHeader.vue';
import QuestionSingleHeader from '../components/pieces/question/QuestionSingleHeader.vue';
import QuestionSingleDetails from '../components/sections/QuestionSingleDetails.vue';
import ThemeFooter from '../components/common/ThemeFooter.vue';

export default {
    name: 'QuestionSingle',
    components: {
        ThemeHeader,
        QuestionSingleHeader,
        QuestionSingleDetails,
        ThemeFooter,
    },
    data() {
        return {

        }
    }
}
</script>